import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectConfiguration } from '../../model/resource';
import { FormControl, FormGroup } from '@angular/forms';

export interface ITimer {
    horas: number,
    minutos: number
}

@Component({
    selector: 'timer-select',
    templateUrl: './timer-select.component.html',
    styleUrls: ['./timer-select.component.scss']
})
export class TimerSelectComponent implements OnInit {
    horaSelectConfiguration: SelectConfiguration = {
        displayExpr: 'nome',
        valueExpr: 'id',
        defaultValue: { nome: '00', id: 0 },
    };

    minutosSelectConfiguration: SelectConfiguration = {
        displayExpr: 'nome',
        valueExpr: 'id',
        defaultValue: { nome: '00', id: 0 },
    };

    formGroup = new FormGroup({
        horas: new FormControl(''),
        minutos: new FormControl('')
    })

    horasValue = { nome: '00', id: 0 };
    minutosValue = { nome: '00', id: 0 };
    show = false;

    @Input() name!: string;
    @Input() formGroupName!: string;
    @Input() parentFormGroup!: FormGroup;
    @Input() value!: ITimer;

    @Output() valueChange = new EventEmitter();

    constructor() {}

    ngOnInit(): void {
        this.parentFormGroup.addControl(this.formGroupName, this.formGroup);

        this.configurarHorasSelect();
        this.configurarMinutosSelect();

        this.show = true;
    }

    private configurarHorasSelect() {
        const defaultData = [];
        for (let i = 0; i < 24; i++) {
            defaultData.push({
                id: i,
                nome: i.toString().padStart(2, '0')
            });
        }
        this.horaSelectConfiguration.defaultData = defaultData;
    }

    private configurarMinutosSelect() {
        const defaultData = [];
        for (let i = 0; i < 60; i++) {
            defaultData.push({
                id: i,
                nome: i.toString().padStart(2, '0')
            });
        }
        this.minutosSelectConfiguration.defaultData = defaultData;
    }

    changeHora(event: ITimer){
        this.value = {horas: this.horasValue.id, minutos: this.minutosValue.id}
        this.valueChange.emit(this.value);
    }
}
